module.exports = "/img/story-2.0db11487.png";